import { HTTPRequest, HTTPRequestResponse } from '@bimser/common';

export const getOperationData = async (url: string, args: any): Promise<HTTPRequestResponse<any>> =>
	HTTPRequest.post(url, args, {
		headers: { 'Content-Type': 'application/json; charset=utf-8' },
		cache: true
	});
